import { render, staticRenderFns } from "./PendingActivationPage.vue?vue&type=template&id=1a4627c7"
import script from "./PendingActivationPage.vue?vue&type=script&lang=js"
export * from "./PendingActivationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports